const initialState = {
  awsConfig: {},
  searchString: '',
  searchResults: [],
  profile: {},
  agentMobilePhone: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_APPOINTMENTS': {
      return { ...state, ...action.payload };
    }
    case 'SET_APPOINTMENTS_PROFILE_KEYS': {
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload,
        },
      };
    }
    case 'SET_APPOINTMENTS_AGENT_KEYS': {
      return {
        ...state,
        selectedAgent: {
          ...state.selectedAgent,
          ...action.payload,
        },
      };
    }
    case 'CLEAR_APPOINTMENTS_PROFILE': {
      return {
        ...state,
        profile: { ...initialState.profile },
      };
    }
    case 'CLEAR_SELECTED_AGENT': {
      return {
        ...state,
        profile: { ...initialState.profile },
      };
    }
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
